export default "__VITE_ASSET__DtCrX_VB__"